import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { Header, Segment, Icon, Button } from "semantic-ui-react";

import { makePrivateApiCall } from "utilities/dist/api";
import { isCompanyFeatureActive } from "utilities/dist/company/helpers";
import { CompanyFeatures } from "utilities/dist/company/constants";

import { InvoiceComponentSummarizedList } from "../components/summarized-list";

const InvoiceContainerRecent = () => {
    const [invoices, setInvoices] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const isCustomerInvoiceNumberingActive = useSelector(({ auth }) =>
        isCompanyFeatureActive(auth.user.company, CompanyFeatures.CUSTOMER_INVOICE_NUMBERING)
    );

    useEffect(() => {
        setLoading(true);
        const loadInvoices = () =>
            makePrivateApiCall({ url: "/invoice/recent" })
                .then(res => {
                    setLoading(false);
                    if (res.data) {
                        setInvoices(res.data);
                    }
                })

                .catch(() => setLoading(false));

        loadInvoices();
    }, []);

    if (!isLoading && isEmpty(invoices)) {
        return (
            <Segment placeholder vertical>
                <Header icon>
                    <Icon name="newspaper outline" />
                    You have not created any invoice yet.
                </Header>
                <Button positive as={Link} to="/invoice/create">
                    Create Invoice
                </Button>
            </Segment>
        );
    }

    return <InvoiceComponentSummarizedList {...{ invoices, isCustomerInvoiceNumberingActive }} />;
};

export default InvoiceContainerRecent;
